export default {"src":"/_next/static/media/eye-slash-black.14325ffc.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};